<template>
  <div id="input-todo">
    <h1>New Todo</h1>
    <b-form @reset="onReset">
      <h3>
        Category
        <span v-on:click="showCtg = !showCtg">
          <i class="fas fa-cog fa-0.6x"></i>
        </span>
      </h3>
      <b-form-select v-model="form.ctg" :options="ctgs" class="mb-3" /><br/>
      <h3>Title</h3>
      <b-form-input type="text" v-model="form.title" placeholder="Enter your name"></b-form-input><br/>
      <h3>Content</h3>
      {{ form.user }}
      <b-form-textarea id="textarea1"
                          v-model="form.content"
                          placeholder="Enter something"
                          :rows="3"
                          :max-rows="6">
      </b-form-textarea><br/>
      <h3>DeadLine</h3>
      <b-form-input v-model="form.deadline" type="date"></b-form-input><br />
      <b-button v-on:click="onSubmit" variant="primary">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
     </b-form>

     <modal v-if="showModal" @close="showModal = false">
       <h3 slot="header">경고</h3>
       <span slot="footer" @click="showModal = false" style="margin-right: 4rem; ">
         모든 입력 폼을 채워주세요
         <i class="closeModalBtn fas fa-times" aria-hidden="true"></i>
       </span>
     </modal>

     <modal v-if="showCtg" @close="showCtg = false">
       <b-button variant="danger" slot="close" @click="showCtg=false">닫기</b-button>
       <h3 slot="header">카테고리 설정</h3>
       <div slot="content" class="ctgSet">
         <ul>
           <li v-for="ctg in ctgs" :key="ctg.value">
             {{ctg.value}}
             <span v-on:click="deleteCtg(ctg.value)">
               <i class="fas fa-times-circle" style="color:red;"></i>
             </span>
           </li>
         </ul>
       </div>
       <span slot="footer">
         <b-form inline>
          <b-input v-model="newCtg" style="font-size:1.3rem;"></b-input>
          <b-button variant="success" v-on:click="addCtg">추가</b-button>
         </b-form>
       </span>
     </modal>

  </div>
</template>
<script>
import Modal from './common/Modal.vue';
import { authRef } from '../store/db.js';

export default {
  data(){
    return{
      form:{
        ctg:'',
        title:'',
        content:'',
        deadline:''
      },
      showModal: false,
      showCtg: false,
      newCtg:'',
      user:''
    }
  },
  methods:{
    onSubmit () {
      if (this.form.title !== "" && this.form.ctg !== "" && this.form.content !=="" && this.form.date !=="") {
        this.$store.dispatch('addTodo',this.form);
        this.clearInput();
        history.back();
      } else {
        this.showModal = !this.showModal;
      }
    },
    clearInput() {
      this.onReset();
    },
    onReset () {
      this.form.ctg = null;
      this.form.title = '';
      this.form.content = null;
      this.form.deadline = null;
    }, 
    addCtg() {
      if(this.newCtg !== ''){
        this.$store.dispatch('addCtg', this.newCtg); 
        this.newCtg = ''; 
      } else{
        alert("추가 할 카테고리명을 입력해주세요"); 
      }
    }, 
    deleteCtg(ctg){
      this.$store.dispatch('removeCtg',ctg);
    }
 },
 beforeCreate(){
     authRef.onAuthStateChanged(user=>{
         if(!user) this.$router.push('/');
         else{
             this.$store.commit('userAuth', user);
             this.user = this.$store.getters.getAuth.email;
         }
     })
 },
  created(){
    this.$store.dispatch('getCtgs');
  },
  computed: {
    ctgs(){
      return this.$store.getters.getCtgs.filter((ctg) => {
        if(this.user == ctg.user){
          return this.$store.getters.getCtgs;    
        }
      });     
    }
  },
  components: {
    Modal: Modal,
  }
}
</script>
<style scoped>
#input-todo{
  margin-left: 10%;
  margin-right: 10%;
  border: 1rem solid skyblue;
  padding: 1rem;
}
h3{
  text-align: left;
  margin-bottom: 1%;
}
.ctgSet{
  margin-top: 2%;
  color: black; 
  text-align: left;
  font-size: 1.5rem; 
}
</style>



// WEBPACK FOOTER //
// src/components/TodoNew.vue